import { all, fork, call, takeLatest, put, select } from 'redux-saga/effects';
import api from '@api/api';
import * as actions from '@store/actions/omniAction';
import * as eaActions from '@store/actions/eaAction';
import { showAlert, SHOW_MODAL } from '@store/actions/commonAction';
import { getApiErrorMessage } from '@common/utils/apiHelper';
import { PLAN_PROGRESS_STATUS_INFO } from '@common/constants';

// 설계사 보고서 Json Data 조회
function* searchFpJsonData({ payload }) {
  const { applicationNo, isRewrite } = payload;
  // const formData = new URLSearchParams();
  const formData = new FormData();
  formData.append('tranMode', 'Q');
  formData.append('publishNumber', applicationNo);
  formData.append('docType', '2');

  const response = yield call(api.eaJsonData, { payload: formData });

  const { status, data } = response;
  if (status === 200) {
    if (
      data.tranMsg !== '데이터가 없습니다.' &&
      data.docDataJson !== 'undefined' &&
      data.docDataJson?.length > 0
    ) {
      const parsingJsonData = JSON.parse(data.docDataJson);
      // 재작성의 경우 완료 페이지 초기화
      if (isRewrite) {
        // 전자 - 설계사 보고서 완료 페이지
        if (parsingJsonData.appCompletePage) {
          parsingJsonData.appCompletePage.length = 0;
        } else {
          parsingJsonData.appCompletePage = [];
        }
        // 옴니 - 설계사 보고서 완료 페이지
        if (parsingJsonData.completePage) {
          parsingJsonData.completePage.length = 0;
        } else {
          parsingJsonData.completePage = [];
        }
      }
      yield put({
        type: actions.SEARCH_FP_JSON_DATA_SUCCESS,
        payload: parsingJsonData,
      });
    }
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '보고서 JSON 데이터 조회에 실패하였습니다.',
    );
    console.log('searchFpJsonData() - errorMessage', errorMessage);

    // Track2: 기존에는 에러나도 메시지 노출 후 그대로 진행하였으나, 에러나면 중단하도록 수정
    // yield put({
    //   type: SHOW_MODAL,
    //   payload: {
    //     visible: true,
    //     type: 'info',
    //     msg: errorMessage,
    //   },
    // });

    // 에러나면 닫기
    yield call(closeOmniError);
  }
}

// 설계사 보고서 Json Data 저장
function* saveFpJsonData({ payload }) {
  const jsonData = $utils.makeFpDocDataJson();

  // [Robin]: Track2에서 LP인 경우 LP보고서를 청약이 아닌 옴니청약 단계에서 하므로,
  // 옴니청약 완료 시(라이프 파트너 서명 단계) status를 2로 변경해서 보냄
  const docStatus = payload?.status || '1';

  // const formData = new URLSearchParams();
  const formData = new FormData();
  formData.append('tranMode', 'I');
  formData.append('publishNumber', payload.applicationNo);
  formData.append('docType', '2');
  formData.append('status', docStatus);
  formData.append('docDataJson', JSON.stringify(jsonData));
  formData.append('unDecidedYn', payload.unDecidedYn || 'N');

  const response = yield call(api.eaJsonData, {
    payload: formData,
  });
  const { status, data } = response;

  if (status === 200 && data.tranCode === '0') {
    if (payload.docType) {
      // const docTypeFormData = new URLSearchParams();
      const docTypeFormData = new FormData();
      docTypeFormData.append('tranMode', 'I');
      docTypeFormData.append('publishNumber', payload.applicationNo);
      docTypeFormData.append('docType', payload.docType);
      docTypeFormData.append('status', '1');
      docTypeFormData.append('docDataJson', JSON.stringify(jsonData));

      const { status, data } = yield call(api.eaJsonData, {
        payload: docTypeFormData,
      });

      if (status === 200 && data.tranCode === '0') {
        if (payload.callback) payload.callback(true);
      }
    } else {
      if (payload.callback) payload.callback(true);
    }
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '보고서 JSON 데이터 저장에 실패하였습니다.',
    );
    console.log('saveFpJsonData() - errorMessage', errorMessage);

    // Track2: 기존에는 에러나도 메시지 노출 후 그대로 진행하였으나, 에러나면 중단하도록 수정
    // yield put({
    //   type: SHOW_MODAL,
    //   payload: {
    //     visible: true,
    //     type: 'info',
    //     msg: errorMessage,
    //   },
    // });

    // 에러나면 닫기
    yield call(closeOmniError);
  }
}

// Plan 상세 조회
function* omniSearchPlanDetail({ payload }) {
  const { planEstablishNo, callback } = payload;
  const { status, data } = yield call(api.planDetail, {
    params: { planEstablishNo },
  });

  if (status === 200) {
    yield put({
      type: eaActions.GET_EA_PLAN_DETAIL_SUCCESS,
      payload: data,
    });

    // 상품 상세 조회
    yield put(actions.getOmniProductDetail(data));

    // 비교 안내문 조회
    yield put(
      actions.getOmnPublishPlanInfoOmni({ applicationNo: data.applicationNo }),
    );

    yield put({
      type: actions.SEARCH_ESTABLISH_INFO,
      payload: data.beforeApplicationNo || data.applicationNo,
    });

    if (typeof callback === 'function') callback(data);
  } else {
    // hanjy: Plan 상세 조회 에러 처리
    yield put({
      type: eaActions.GET_EA_PLAN_DETAIL_FAIL,
    });
  }
}

/**
 * 비교안내문 계약 정보 조회
 */
function* getOmnPublishPlanInfoOmni({ payload }) {
  const response = yield call(api.getOmnPublishPlanInfo, {
    params: { applicationNo: payload.applicationNo },
  });
  const { status, data } = response;

  if (status === 200) {
    yield put(actions.changeOmniState({ type: 'insuranceCompareData', data }));

    // 체크리스트 노출 여부 세팅
    yield put(
      actions.changeOmniState({
        type: 'checkListYn',
        data: data.checkListYn,
      }),
    );

    yield put(
      actions.changeOmniState({
        type: 'supRate',
        data: data.supRate,
      }),
    );
    yield put(
      actions.changeOmniState({
        type: 'meetOrgTerm',
        data: data.meetOrgTerm,
      }),
    );
  } else {
    const errorMessage = getApiErrorMessage(response);
    yield put(showAlert({ message: errorMessage }));
  }

  if (typeof payload.callback === 'function') {
    payload.callback({ status, data, payload });
  }
}

// 전자 서명 저장
function* omniSaveSignatureData({ payload }) {
  const { signData } = yield select(state => state.eaReducer);
  const formData = new FormData();
  // const formData = new URLSearchParams();
  formData.append('tranMode', 'I'); // 처리모드 I:입력, Q:조회
  formData.append('signType', '2'); // 사인타입 1:성명, 2:서명
  formData.append('signGubun', 'E'); // 사인구분 E:설계사, P:고객
  formData.append('signData', payload.signData); // base64형태사인값
  formData.append('empNumber', payload.empNumber); // 설계사 id

  const { status, data } = yield call(api.eaSignatureData, {
    payload: formData,
  });

  if (status === 200 && data.tranCode === '0') {
    yield put({
      type: actions.OMNI_SAVE_SIGNATURE_DATA_SUCCESS,
      payload: {
        key: 'lpSignInfo',
        data: {
          ...signData.lpSignInfo,
          signData: payload.signData,
        },
      },
    });
    if (payload.callback) payload.callback(true);
    return true;
  } else {
    return false;
  }
}

// 전자 성명 저장
function* omniSaveSignNameData({ payload }) {
  const { signData } = yield select(state => state.eaReducer);
  const formData = new FormData();
  // const formData = new URLSearchParams();
  formData.append('tranMode', 'I'); // 처리모드 I:입력, Q:조회
  formData.append('signType', '1'); // 사인타입 1:성명, 2:서명
  formData.append('signGubun', 'E'); // 사인구분 E:설계사, P:고객
  formData.append('signData', payload.signData); // base64형태사인값
  formData.append('empNumber', payload.empNumber); // 설계사 id

  const { status, data } = yield call(api.eaSignatureData, {
    payload: formData,
  });

  if (status === 200 && data.tranCode === '0') {
    // 성명 저장
    yield put({
      type: actions.OMNI_SAVE_SIGNATURE_DATA_SUCCESS,
      payload: {
        key: 'lpSignInfo',
        data: {
          ...signData.lpSignInfo,
          nameData: payload.signData,
        },
      },
    });
    if (payload.callback) payload.callback(true);
    return true;
  } else {
    return false;
  }
}

// 전자 성명, 서명 저장
function* omniSaveSignBothData({ payload }) {
  const saveNameStatus = yield call(omniSaveSignNameData, {
    payload: {
      signData: payload.signNameData,
      signId: payload.nameId,
      empNumber: payload.empNumber,
    },
  });

  const saveSignStatus = yield call(omniSaveSignatureData, {
    payload: {
      signData: payload.signatureData,
      signId: payload.signId,
      empNumber: payload.empNumber,
    },
  });

  if (saveNameStatus && saveSignStatus) {
    if (payload.callback) payload.callback(true);
  } else {
    const saveNameStatusMsg = saveNameStatus ? '성공' : '실패';
    const saveSignStatusMsg = saveSignStatus ? '성공' : '실패';
    const errorMessage = `전자 성명, 서명 저장 중 에러가 발생했습니다. (전자 성명 : ${saveNameStatusMsg} / 전자 서명 : ${saveSignStatusMsg})`;

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 전자 서명/성명 조회
function* omniSearchSignatureData({ payload }) {
  const formData = new FormData();
  // const formData = new URLSearchParams();
  formData.append('tranMode', 'Q'); // 처리모드 I:입력, Q:조회
  formData.append('signGubun', 'E'); // 사인구분 E:설계사, P:고객
  formData.append('empNumber', payload.empNumber); // // 설계사 id

  const response = yield call(api.eaSignatureData, {
    payload: formData,
  });

  const { status, data } = response;

  if (status === 200) {
    const resultData = data.signList;

    if (resultData.length > 0) {
      yield put({
        type: actions.OMNI_SAVE_SIGNATURE_DATA_SUCCESS,
        payload: {
          key: 'lpSignInfo',
          data: {
            signData: resultData.filter(data => data.signType === '2')[0]
              ? resultData.filter(data => data.signType === '2')[0].signData
              : '',
            nameData: resultData.filter(data => data.signType === '1')[0]
              ? resultData.filter(data => data.signType === '1')[0].signData
              : '',
            signDate: resultData.filter(data => data.signType === '1')[0]
              .signDate,
          },
        },
      });
    }
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '전자 성명/서명 조회에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 대면확인서 저장
function* saveInterViewData({ payload }) {
  const jsonData = $utils.makeInterviewDocDataJson();

  // const formData = new URLSearchParams();
  const formData = new FormData();
  formData.append('tranMode', 'I');
  formData.append('publishNumber', payload.applicationNo);
  formData.append('docType', '3');
  formData.append('status', '1');
  formData.append('docDataJson', JSON.stringify(jsonData));

  const response = yield call(api.eaJsonData, {
    payload: formData,
  });
  const { status, data } = response;

  if (status === 200 && data.tranCode === '0') {
    if (payload.callback) payload.callback(true);
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '대면 확인서 저장에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 옴니 모바일 전송
function* sendSmsOmni({ payload }) {
  const response = yield call(api.sendSmsOmni, {
    payload: {
      publishNumber: payload.applicationNo,
      docType: payload.docType ? payload.docType : '1',
      republishType: payload.docType === '5' ? '' : payload.republishType, // republishType: PND 보내면 400 에러
      policyNo: payload.policyNo || '',
      ownerName: payload.ownerName || '',
      insuredName: payload.insuredName || '',
      insuredCustId: payload.insuredCustId || '',
      ownerCustId: payload.ownerCustId || '',
      sendType: payload.sendType || '',
      itemNo: payload.itemNo || '',
      itemSno: payload.itemSno || '',
      undwTpCd: payload.undwTpCd || '',
      undwSno: payload.undwSno || '',
    },
  });
  const { status } = response;
  // const applicationNo = payload.applicationNo;
  if (status === 200) {
    // yield put({
    //   type: eaActions.CHANGE_PLAN_STATUS,
    //   payload: {
    //     applicationNo: applicationNo,
    //     status: 'P',
    //     republishType: payload.republishType,
    //   },
    // });

    if (payload.callback) payload.callback(true);
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '옴니 모바일 전송에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 설계사 보고서 작성 완료 후 xml 동기화
function* jsonDataToXml({ payload }) {
  const response = yield call(api.registeSchedulerEaPdf, {
    params: {
      publishNumber: payload.applicationNo,
      schedulerType: payload.schedulerType,
      rePublishYn: payload.isRepublish,
      omniYn: payload.omniYn,
      isCheckList: payload.isCheckList,
    },
  });
  const { status, data } = response;

  if (status === 200) {
    if (payload.callback) payload.callback(data);
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '보고서 작성 완료 후 XML 동기화에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 보고서 잡리스트에 등록하기
function* registerReportToJoblist({ payload }) {
  const jsonData = $utils.makeFpDocDataJson();

  // const formData = new URLSearchParams();
  const formData = new FormData();
  formData.append('tranMode', 'I');
  formData.append('publishNumber', payload.applicationNo);
  formData.append('docType', '2');
  formData.append('status', '2');
  formData.append('docDataJson', JSON.stringify(jsonData));

  const response = yield call(api.eaJsonData, {
    payload: formData,
  });
  const { status, data } = response;

  if (status === 200 && data.tranCode === '0') {
    // 약관수령동의서 완료
    if (!payload.isOmni) {
      // const formData = new URLSearchParams();
      const formData = new FormData();
      formData.append('tranMode', 'I');
      formData.append('publishNumber', payload.applicationNo);
      formData.append('docType', '4');
      formData.append('status', '2');
      formData.append(
        'docDataJson',
        JSON.stringify({
          txId: '',
          COMMON_PUBLISH_NO: payload.applicationNo,
        }),
      );
      const { status, data } = yield call(api.eaJsonData, {
        payload: formData,
      });
      if (status === 200 && data.tranCode === '0')
        if (payload.callback) payload.callback(true);
    } else {
      if (payload.callback) payload.callback(true);
    }
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '보고서 잡리스트 등록에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 대면확인서 잡리스트에 등록하기
function* registerInterviewToJoblist({ payload }) {
  const jsonData = $utils.makeInterviewDocDataJson();

  // const formData = new URLSearchParams();
  const formData = new FormData();
  formData.append('tranMode', 'I');
  formData.append('publishNumber', payload.applicationNo);
  formData.append('docType', '3');
  formData.append('status', '2');
  formData.append('docDataJson', JSON.stringify(jsonData));

  const response = yield call(api.eaJsonData, {
    payload: formData,
  });
  const { status, data } = response;

  if (status === 200 && data.tranCode === '0') {
    if (payload.callback) payload.callback(true);
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '대면확인서 잡리스트 등록에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 옴니청약 발송 취소
function* cancelSendOmni({ payload }) {
  const applicationNo = payload.applicationNo;
  const { status, data } = yield call(api.cancelSendOmni, {
    params: { applicationNo },
  });

  // resultCode === '0' ->  정상처리
  if (status === 200 && data.resultCode === '0') {
    yield put({
      type: eaActions.CHANGE_PLAN_STATUS,
      payload: {
        applicationNo: applicationNo,
        status: PLAN_PROGRESS_STATUS_INFO.omniCanceled,
      },
    });
  } else {
    yield put(
      showAlert({
        message: data?.resultMsg ?? '옴니청약 발송 취소 실패 했습니다.',
      }),
    );
  }

  if (payload.callback) payload.callback();
}

// 발행당시 고객정보 조회
function* searchEstablishInfo({ payload }) {
  const response = yield call(api.searchEstablishInfo, {
    params: { applicationNo: payload },
  });
  const { status, data } = response;

  if (status === 200) {
    yield put({
      type: actions.SEARCH_ESTABLISH_INFO_SUCCESS,
      payload: { ownerInfo: data.ownerInfo, insuredInfo: data.insuredInfo },
    });
  } else {
    const errorMessage = getApiErrorMessage(
      response,
      '발행당시 고객 정보 조회에 실패하였습니다.',
    );

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 상품 상세 조회
function* getOmniProductDetail({ payload }) {
  const {
    channelInfo: { cdVal },
  } = yield select(state => state.userReducer);
  const {
    mainProductCode: productCode,
    calculateDate,
    insuredPrspInfo: {
      custNo,
      insuranceAge,
      genderCode,
      legalAge: flAge,
      jobCode,
      drvCode,
      custKind,
    },
  } = payload;
  const calculateDateString = calculateDate.replace(/[^0-9]/g, '');

  const response = yield call(api.searchProductDetail, {
    payload: {
      chnlCd: cdVal,
      productCode,
      calculateDate: calculateDateString,
      custNo,
      insuranceAge,
      genderCode,
      flAge,
      jobCode,
      drvCode,
      custKind,
    },
  });

  const isSuccess = $utils.checkApiSuccess(response);
  if (isSuccess) {
    const data = $utils.getApiData(response);
    yield put(actions.setOmniProductDetail(data));

    // 번들코드 조회
    yield put(eaActions.setBundleCodeInfo({ productDetail: data }));
  } else {
    const error = $utils.getApiErrorMessage(response);
    console.log('getOmniProductDetail() - error', error);
  }
}

// 에러 났을 때, 옴니청약 팝업 닫는 함수
function* closeOmniError(
  errorMessage = '청약 저장이 원활하지 않습니다. 다음에 다시 진행해주세요.',
) {
  yield put(showAlert({ message: errorMessage }));
  yield put(actions.hideOmniPopup());
}

function* watchOmni() {
  yield takeLatest(actions.SEARCH_FP_JSON_DATA, searchFpJsonData);
  yield takeLatest(actions.SAVE_FP_JSON_DATA, saveFpJsonData);
  yield takeLatest(actions.OMNI_SEARCH_PLAN_DETAIL, omniSearchPlanDetail);
  yield takeLatest(actions.GET_OMNI_PRODUCT_DETAIL, getOmniProductDetail);

  yield takeLatest(actions.OMNI_SAVE_SIGN_BOTH_DATA, omniSaveSignBothData);
  yield takeLatest(actions.OMNI_SAVE_SIGNATURE_DATA, omniSaveSignatureData);
  yield takeLatest(actions.OMNI_SEARCH_SIGNATURE_DATA, omniSearchSignatureData);
  yield takeLatest(actions.SAVE_INTERVIEW_DATA, saveInterViewData);
  yield takeLatest(actions.SEND_SMS_OMNI, sendSmsOmni);
  yield takeLatest(actions.JSON_DATA_TO_XML, jsonDataToXml);
  yield takeLatest(actions.REGISTER_REPORT_TO_JOBLIST, registerReportToJoblist);
  yield takeLatest(actions.CANCEL_SEND_OMNI, cancelSendOmni);
  yield takeLatest(
    actions.REGISTER_INTERVIEW_TO_JOBLIST,
    registerInterviewToJoblist,
  );
  yield takeLatest(actions.SEARCH_ESTABLISH_INFO, searchEstablishInfo);
  yield takeLatest(
    actions.GET_OMN_PUBLISH_PLAN_INFO_OMNI,
    getOmnPublishPlanInfoOmni,
  );
}

export default function* omniSaga() {
  yield all([fork(watchOmni)]);
}
